import { create } from "zustand";

export type ToastKind = "success" | "error" | "info" | "warning";

export type ToastItem = {
  id: string;
  kind: ToastKind;
  message: string;
};

type AsyncFeedbackState = {
  httpPending: number;
  operationLabel: string | null;
  toasts: ToastItem[];
  beginRequest: () => void;
  endRequest: () => void;
  setOperationLabel: (label: string | null) => void;
  pushToast: (kind: ToastKind, message: string) => void;
  dismissToast: (id: string) => void;
};

let toastSeq = 0;

export const useAsyncFeedbackStore = create<AsyncFeedbackState>((set, get) => ({
  httpPending: 0,
  operationLabel: null,
  toasts: [],

  beginRequest: () =>
    set((s) => ({ httpPending: s.httpPending + 1 })),

  endRequest: () =>
    set((s) => ({ httpPending: Math.max(0, s.httpPending - 1) })),

  setOperationLabel: (operationLabel) => set({ operationLabel }),

  pushToast: (kind, message) => {
    const id = `toast-${++toastSeq}`;
    set((s) => ({ toasts: [...s.toasts, { id, kind, message }] }));
    window.setTimeout(() => {
      if (get().toasts.some((t) => t.id === id)) {
        get().dismissToast(id);
      }
    }, 4500);
  },

  dismissToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export function isGlobalLoading(): boolean {
  const { httpPending, operationLabel } = useAsyncFeedbackStore.getState();
  return httpPending > 0 || operationLabel != null;
}

export function globalLoadingLabel(): string {
  const { httpPending, operationLabel } = useAsyncFeedbackStore.getState();
  if (operationLabel) return operationLabel;
  if (httpPending > 0) return "Carregando dados…";
  return "";
}
